import firebase from 'firebaseHelpers'
import { getUserInfos, } from 'firebaseHelpers/users'

export const SESSION_LOGIN = 'SESSION_LOGIN';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';

export const login = (user) => dispatch => {
  const parkingsFormated = user.parkings ? user.parkings.map((parking) => ({ id: parking.id })): []
  const delegateFormated = user.delegate ? user.delegate.map((delegate) => ({ id: delegate.id })): []

  localStorage.setItem('user', JSON.stringify({ ...user, delegate: delegateFormated, parkings: parkingsFormated, }))
  dispatch({
    user,
    type: SESSION_LOGIN
  });
}

export const logout = () => async dispatch => {
  localStorage.setItem('user', null)
  await firebase.auth().signOut()
  dispatch({
    type: SESSION_LOGOUT
  })
}

export const verifyAuth = () => dispatch => {
  firebase.auth().onAuthStateChanged(async (user) => {
    if (user) {
      const userInfos = await getUserInfos(user.uid)
      console.log(userInfos)
      dispatch(login({ id: user.uid, ...userInfos }))
    } else {
      dispatch(logout())
    }
  })
}
